import { differenceInSeconds, intervalToDuration } from "date-fns";
import { useCallback, useEffect, useState } from "react";
import { isExpiredInSeconds } from "../dates";

export function useCountdownTimer(expiresAt: number | undefined) {
  const [timeLeft, setTimeLeft] = useState<Duration>();

  const calculateTimeLeft = useCallback(() => {
    if (!expiresAt || isExpiredInSeconds(expiresAt)) return;

    const now = new Date();
    const expirationTime = new Date(expiresAt * 1000);

    const difference = differenceInSeconds(expirationTime, now);

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return intervalToDuration({ start: now, end: expirationTime });
  }, [expiresAt]);

  useEffect(() => {
    setTimeLeft(calculateTimeLeft());
  }, [calculateTimeLeft]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [calculateTimeLeft]);

  return timeLeft;
}
